"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatForumsAudienceCopy = exports.canCreateTopicOnForum = exports.canPostOnForums = exports.canSeeForum = exports.canAccessForums = exports.canSeeForumsNav = exports.matchesForumsAudience = exports.isTypeSlugInList = exports.hasActivePaidMembership = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var MembershipStatus_1 = require("../MembershipStatus");
var User_1 = require("../User");
var forumPartner_1 = require("./forumPartner");
var hasActivePaidMembership = function (membership) {
    if (!membership)
        return false;
    if (membership.status !== MembershipStatus_1.MEMBERSHIP_STATUS.PAID)
        return false;
    var now = (0, dayjs_1.default)();
    var issueDate = membership.issueDate ? (0, dayjs_1.default)(membership.issueDate) : null;
    var expireDate = membership.expireDate ? (0, dayjs_1.default)(membership.expireDate) : null;
    if (!issueDate || !expireDate)
        return false;
    if (issueDate.isAfter(now))
        return false;
    if (expireDate.isBefore(now))
        return false;
    return true;
};
exports.hasActivePaidMembership = hasActivePaidMembership;
var membershipSlug = function (membership) {
    var _a, _b;
    var slug = (_a = membership === null || membership === void 0 ? void 0 : membership.membershipTypeSlug) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (slug)
        return slug;
    return (_b = membership === null || membership === void 0 ? void 0 : membership.membershipType) === null || _b === void 0 ? void 0 : _b.toLowerCase();
};
var isTypeSlugInList = function (slug, list) {
    if (!slug || !list || list.length === 0)
        return false;
    var normalized = slug.toLowerCase();
    return list.some(function (item) { return item.toLowerCase() === normalized; });
};
exports.isTypeSlugInList = isTypeSlugInList;
var matchesForumsAudience = function (membership, audienceTypeSlugs) {
    if (!membership)
        return false;
    return (0, exports.isTypeSlugInList)(membershipSlug(membership), audienceTypeSlugs);
};
exports.matchesForumsAudience = matchesForumsAudience;
/** Sidebar + route shell: published Forums are visible to every signed-in member. */
var canSeeForumsNav = function (role, flags) {
    if ((0, User_1.isAdmin)(role))
        return true;
    return flags.forums === true;
};
exports.canSeeForumsNav = canSeeForumsNav;
/** Who may use Forums (list topics, read, post) — Settings audience, not a rate SKU flag. */
var canAccessForums = function (role, flags, membership, audienceTypeSlugs) {
    if (audienceTypeSlugs === void 0) { audienceTypeSlugs = []; }
    if ((0, User_1.isAdmin)(role))
        return true;
    if (!flags.forums)
        return false;
    if (!(0, exports.hasActivePaidMembership)(membership))
        return false;
    return (0, exports.matchesForumsAudience)(membership, audienceTypeSlugs);
};
exports.canAccessForums = canAccessForums;
/** Per-forum filter. Empty privacyTypeSlugs = every Layer-1 user. Cannot widen past audience. */
var canSeeForum = function (role, flags, membership, audienceTypeSlugs, privacyTypeSlugs) {
    if (privacyTypeSlugs === void 0) { privacyTypeSlugs = []; }
    if ((0, User_1.isAdmin)(role))
        return true;
    if (!(0, exports.canAccessForums)(role, flags, membership, audienceTypeSlugs))
        return false;
    if (!privacyTypeSlugs.length)
        return true;
    return (0, exports.matchesForumsAudience)(membership, privacyTypeSlugs);
};
exports.canSeeForum = canSeeForum;
var canPostOnForums = function (role, flags, membership, posting, audienceTypeSlugs) {
    var _a, _b;
    if (posting === void 0) { posting = {}; }
    if (audienceTypeSlugs === void 0) { audienceTypeSlugs = []; }
    if ((0, User_1.isAdmin)(role))
        return true;
    if (!(0, exports.canAccessForums)(role, flags, membership, audienceTypeSlugs))
        return false;
    if (posting.forumPostingRestricted)
        return false;
    if (!posting.forumGuidelinesAcceptedAt)
        return false;
    if ((0, forumPartner_1.isPartnerForForumBrand)(role, (_a = posting.membershipTypeSlug) !== null && _a !== void 0 ? _a : membership === null || membership === void 0 ? void 0 : membership.membershipTypeSlug) &&
        !((_b = posting.forumBusinessName) === null || _b === void 0 ? void 0 : _b.trim())) {
        return false;
    }
    return true;
};
exports.canPostOnForums = canPostOnForums;
/** Admins always can. Members only if they can post and this forum allows member-created topics. */
var canCreateTopicOnForum = function (role, flags, membership, posting, audienceTypeSlugs, membersCanCreateTopics) {
    if (posting === void 0) { posting = {}; }
    if (audienceTypeSlugs === void 0) { audienceTypeSlugs = []; }
    if (membersCanCreateTopics === void 0) { membersCanCreateTopics = false; }
    if ((0, User_1.isAdmin)(role))
        return true;
    if (!membersCanCreateTopics)
        return false;
    return (0, exports.canPostOnForums)(role, flags, membership, posting, audienceTypeSlugs);
};
exports.canCreateTopicOnForum = canCreateTopicOnForum;
var formatForumsAudienceCopy = function (labels) {
    var names = labels.map(function (label) { return label.trim(); }).filter(Boolean);
    if (names.length === 0) {
        return 'Forums are not included with your current membership.';
    }
    if (names.length === 1) {
        return "Forums are included with ".concat(names[0], " membership.");
    }
    var last = names[names.length - 1];
    var rest = names.slice(0, -1).join(', ');
    return "Forums are included with ".concat(rest, " and ").concat(last, " memberships.");
};
exports.formatForumsAudienceCopy = formatForumsAudienceCopy;
//# sourceMappingURL=forumAccess.js.map